import { MainPane, PaneHeader, type BreadcrumbEntry } from '@batiflow/ui';
import { __css, Title2, tokens } from '@fluentui/react-components';
import type { ReactNode } from 'react';
import { useStandalone } from '@/shared/components/standalone-frame';

const useStyles = __css({"content":{"B7ck84d":"f1ewtqcl","mc9l5x":"f22iagw","Beiy3e4":"f1vx9l62","Belr9w4":"f1noh358","Dbcxam":0,"rjzwhg":0,"Bblux5w":"f16epzkf","Bnt446c":0,"B1hrpyx":0,"Fjva8n":"fjshy37"},"standaloneContent":{"Bnt446c":0,"B1hrpyx":0,"Fjva8n":"fgdu4nw","Dbcxam":0,"rjzwhg":0,"Bblux5w":"fnllxr2"},"standaloneHead":{"mc9l5x":"f22iagw","Eh141a":"fni485r","Bt984gj":"f122n59","Brf1p80":"f1869bpl","i8kkvl":"f1xcgk68","Belr9w4":"f1wn3y0l"},"title":{"Bo78w4l":0,"Cgygva":0,"yil37a":"f8ntp42","Btd35i7":"fjksvth"}});

export interface SpaceFrameProps {
  title: string;
  breadcrumb?: readonly BreadcrumbEntry[];
  /** The one primary action of the view. */
  actions?: ReactNode;
  /** Between the title bar and the tabs (the external-space banner, the space summary). */
  banner?: ReactNode;
  tabs?: ReactNode;
  children: ReactNode;
}

/**
 * Frame of a shared-space page: the shell's main pane with its title bar, banner and tabs, or,
 * for a person without any organisation (a guest, no shell yet), the title above the content in a
 * plain column.
 */
export function SpaceFrame({
  title,
  breadcrumb,
  actions,
  banner,
  tabs,
  children,
}: SpaceFrameProps) {
  const styles = useStyles();
  const standalone = useStandalone();
  if (standalone) {
    return (
      <>
        <div className={styles.standaloneHead}>
          <Title2 as="h1" className={styles.title}>
            {title}
          </Title2>
          {actions}
        </div>
        {banner}
        {tabs}
        <div className={`${styles.content} ${styles.standaloneContent}`}>{children}</div>
      </>
    );
  }
  return (
    <MainPane
      header={
        <PaneHeader
          title={title}
          {...(breadcrumb ? { breadcrumb } : {})}
          {...(actions ? { actions } : {})}
        />
      }
      {...(banner ? { banner } : {})}
      {...(tabs ? { tabs } : {})}
    >
      <div className={styles.content}>{children}</div>
    </MainPane>
  );
}


import "/opt/batiflow/app/apps/web/src/features/spaces/space-frame.griffel.css";